import * as React from 'react'

import { css, styled } from '$utils/theme'
import {
  alignmentCss,
  AlignmentProps,
  HorizontalMarginProps,
  horizontalMarginsCss,
  VerticalMarginProps,
  verticalMarginsCss,
  visibilityCss,
} from '$utils/theme/css'

interface Props {
  className?: string
  onlyMobile?: boolean
  onlyDesktop?: boolean
  flex?: boolean
  inline?: boolean
  as?: 'div' | 'ul' | 'ol'
  key?: any
  myRef?: any
  // válido sólo con flex: true
  alignItems?: 'start' | 'center' | 'end' | 'baseline'
  justify?: 'end' | 'between' | 'center'
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
  width?: number
}

const justifyToValueMapping = {
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
}

const BlockRaw: React.SFC<Props & VerticalMarginProps & HorizontalMarginProps & AlignmentProps> = ({
  as: As = 'div',
  className,
  children,
  key,
  myRef,
}) => (
  <As ref={myRef} className={className} key={key}>
    {children}
  </As>
)

export const Block = styled(BlockRaw)`
  position: relative;
  display: ${p => p.inline && 'inline-block'};

  ${p =>
    p.flex &&
    css`
      display: ${p.inline ? 'inline-flex' : 'flex'};
      align-items: ${p.alignItems};
      justify-content: ${p.justify && justifyToValueMapping[p.justify]};
      flex-wrap: ${p.wrap};
    `};

  ${p =>
    p.width > 0 &&
    css`
      width: ${`${p.width}%`};
    `}

  ${horizontalMarginsCss};
  ${verticalMarginsCss};
  ${alignmentCss};
  ${visibilityCss};
`



// WEBPACK FOOTER //
// ./src/views/components/Layout/Block/Block.tsx